// extracted by mini-css-extract-plugin
export default {"root":"wND56","message":"_1tzmC","button":"qpJGV"};